import { Box, IconButton, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import StoryList from '../StoryList';
import { IStory } from '../../services/types';

interface IProps {
  open: boolean;
  onClose: () => void;
  onError?: (e: Error) => void;
  onClick: (story: IStory) => void;
  filter?: 'story' | 'season';
  title?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    bottom: 40,
    right: 40,
    backgroundColor: theme.palette.background.paper,
    width: 340,
    height: 578,
    borderRadius: '2px',
    boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
  },
  titleWrap: {
    paddingTop: 22,
    paddingLeft: 19,
  },
  modalPaper: {
    position: 'relative',
    width: 760,
    minHeight: 310,
    maxHeight: 750,
  },
  modalCloseButton: {
    position: 'absolute',
    right: 8,
    top: 10,
  },
  modalRefreshButton: {
    position: 'absolute',
    right: 52,
    top: 10,
  },
  addModalTabRoot: {
    minWidth: '60px !important',
    marginLeft: 8,
    marginRight: 8,
    textTransform: 'none',
  },
  addModalTabRootLeft: {
    minWidth: '60px !important',
    marginLeft: 15,
    marginRight: 8,
  },
  addModalTabWrapper: {
    fontSize: 14,
    textTransform: 'none',
  },
  addModalTabContentWrap: {
    paddingTop: 0,
    paddingBottom: 15,
    top: 0,
    left: 0,
  },
  listItem: {
    alignItems: 'baseline',
    paddingTop: 0,
    paddingBottom: 0,
  },
  listItemText: {
    fontSize: 14,
    paddingLeft: 10,
  },
  alertedListItemText: {
    flex: 1,
    fontSize: 14,
    paddingLeft: 10,
    color: '#f44336',
  },
  filterQuery: { padding: '0 20px 6px' },
}));

const StorySelectModal = (props: IProps): JSX.Element | null => {
  const classes = useStyles();

  const { open, title, filter, onClick, onClose } = props;

  if (!open) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.titleWrap}>
        <Typography component="h6" variant="subtitle1" style={{ fontWeight: 500 }}>
          {title || (filter === 'season' ? 'Select a Season' : 'Select a Story')}
        </Typography>
      </Box>
      <IconButton className={classes.modalCloseButton} onClick={() => onClose()}>
        <CloseIcon style={{ color: '#bebebe' }} />
      </IconButton>
      <StoryList
        readonly={true}
        fullWidth={true}
        height={472}
        onItemClick={story => {
          onClick(story);
        }}
        filter={filter}
      />
    </Box>
  );
};

export default StorySelectModal;
